import { UserImageWithFallback } from "@/react/components/shared/uikit/UserImageWithFallback";
import { Typography } from "@circle-react-uikit/Typography";

interface UserInfoProps {
  avatar_url?: string;
  email?: string;
  fullName: string;
  initials: string;
}

export const UserInfo = ({
  fullName,
  email,
  initials,
  avatar_url,
}: UserInfoProps) => (
  <>
    <div>
      <Typography.TitleSm color="text-default" weight="bold">
        {fullName}
      </Typography.TitleSm>
      <Typography.BodySm color="text-default">{email}</Typography.BodySm>
    </div>
    <div className="flex size-10 items-center justify-center overflow-hidden rounded-full bg-gray-200">
      {avatar_url ? (
        <UserImageWithFallback src={avatar_url} name={fullName} size="10" />
      ) : (
        <Typography.BodySm color="text-default">{initials}</Typography.BodySm>
      )}
    </div>
  </>
);
